module.exports = __webpack_public_path__ + "static/media/OpenSeas_web_2_preview.e5261631.jpg";